export enum FlaggedFeature {
  ElemntMultisportPage,
  ElemntPlannedWorkouts,
}
